(() => {
  if (window.__smoofProofPdfV6) return;
  window.__smoofProofPdfV6 = true;
  window.__smoofProofPdfV5 = true;
  window.__smoofProofPdfV4 = true;
  window.__smoofProofPdfV3 = true;

  const VERSION =
    'surface-aware-production-v8-qr-parent-visibility';

  const REQUIRED_RENDERER_BUILD =
    'v3.1-native-nfc-20260814';

  const JSPDF_URL =
    'https://cdn.jsdelivr.net/npm/jspdf@4.2.1/+esm';

  const SMOOF_LOGO_SVG =
    'data:image/svg+xml;base64,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';

  const STAGE_SELECTOR =
    '.po-livePreview-stage .konvajs-content';

  const PROOF_ARROW_URLS = {
    left:
      'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Left.svg?v=1785255586',
    right:
      'https://cdn.shopify.com/s/files/1/0996/4136/0721/files/Right.svg?v=1785255586'
  };

  const PREVIEW_INPUT_NAME =
    'properties[SMOOF Proof PDF]';

  const CART_PREVIEW_INPUT_NAME =
    'properties[Vorschau]';

  const PRODUCTION_INPUT_NAME =
    'properties[SMOOF Produktionsvorlage PDF]';

  const PRODUCTION_BLEED_MM =
    2.5;

  const PRODUCTION_DPI =
    600;

  const readyForms = new WeakSet();

  const cartPreviewFiles =
    new WeakMap();

  let dependenciesPromise = null;
  let generationPromise = null;
  let whitePanel = null;
  let currentStage = null;
  let statusOverlay = null;
  let renderPending = false;
  let brandLogoPromise = null;

  const proofArrowSvgCache =
    new Map();

  function isEnglish() {
    return document.documentElement.lang
      .toLowerCase()
      .startsWith('en');
  }

  function text(de, en) {
    return isEnglish() ? en : de;
  }

  function qrState(model = null) {
    return model?.qr || window.SmoofQrGeometryTools?.getState?.() || {};
  }

  function qrVisible(model = null) {
    return qrState(model).visible !== false;
  }

  function qrBackingVisible(model = null) {
    if (!qrVisible(model)) return false;
    if (document.documentElement.dataset.smoofQrBackground === 'transparent') return false;
    const qr = qrState(model);
    if (typeof qr.backingVisible === 'boolean') return qr.backingVisible;
    if (typeof qr.whiteBackground === 'boolean') return qr.whiteBackground;
    return true;
  }

  function qrBackingColor(model = null) {
    const value = String(qrState(model).backingColor || '#FFFFFF');
    return /^#[0-9a-f]{6}$/i.test(value) ? value.toUpperCase() : '#FFFFFF';
  }

  function qrCodeColor(model = null) {
    const value = String(qrState(model).codeColor || '#000000');
    return /^#[0-9a-f]{6}$/i.test(value) ? value.toUpperCase() : '#000000';
  }

  function delay(milliseconds) {
    return new Promise(resolve => {
      window.setTimeout(
        resolve,
        milliseconds
      );
    });
  }

  async function brandLogoPng() {
    if (brandLogoPromise) {
      return brandLogoPromise;
    }

    brandLogoPromise =
      new Promise(
        (resolve, reject) => {
          const image =
            new Image();

          image.onload = () => {
            const canvas =
              document.createElement(
                'canvas'
              );

            canvas.width = 820;
            canvas.height = 333;

            const context =
              canvas.getContext(
                '2d'
              );

            if (!context) {
              reject(
                new Error(
                  'SMOOF logo renderer unavailable'
                )
              );

              return;
            }

            context.clearRect(
              0,
              0,
              canvas.width,
              canvas.height
            );

            context.drawImage(
              image,
              0,
              0,
              canvas.width,
              canvas.height
            );

            resolve(
              canvas.toDataURL(
                'image/png',
                1
              )
            );
          };

          image.onerror = () =>
            reject(
              new Error(
                'SMOOF logo could not be loaded'
              )
            );

          image.src =
            SMOOF_LOGO_SVG;
        }
      );

    return brandLogoPromise;
  }

  async function loadDependencies() {
    if (!dependenciesPromise) {
      dependenciesPromise =
        import(JSPDF_URL).then(
          pdfModule => ({
            jsPDF:
              pdfModule.jsPDF ||
              pdfModule.default?.jsPDF ||
              pdfModule.default
          })
        );
    }

    const dependencies =
      await dependenciesPromise;

    if (
      !dependencies.jsPDF
    ) {
      throw new Error(
        'Proof libraries unavailable'
      );
    }

    return dependencies;
  }

  function getPrintDiameterMm() {
    const variantDiameter =
      Number(
        window
          .SmoofProductVariant
          ?.get?.()
          ?.diameterMm
      );

    if (
      Number.isFinite(
        variantDiameter
      ) &&
      variantDiameter > 0
    ) {
      return variantDiameter;
    }

    const candidates =
      Array.from(
        document.querySelectorAll(
          [
            'input[name*="Größe der Druckfläche"]',
            'input[name*="Druckfläche"]',
            'input[name*="Print area"]',
            'input[name*="print area"]'
          ].join(',')
        )
      );

    const rawValue =
      candidates.find(input =>
        input.offsetParent !== null
      )?.value ||
      candidates[0]?.value ||
      '80';

    const match =
      String(rawValue).match(
        /(\d+(?:[.,]\d+)?)/
      );

    const diameter =
      Number(
        match?.[1]?.replace(
          ',',
          '.'
        )
      );

    return (
      Number.isFinite(diameter) &&
      diameter > 0
    )
      ? diameter
      : 80;
  }

  function getProductTitle() {
    return (
      document.querySelector(
        'main h1'
      )?.textContent.trim() ||
      document.title.split('|')[0]
        .trim() ||
      'SMOOF'
    );
  }

  function createProofId() {
    const time =
      Date.now().toString(36)
        .toUpperCase();

    const random =
      Math.random()
        .toString(36)
        .slice(2, 6)
        .toUpperCase();

    return `SMF-${time}-${random}`;
  }

  function ensureWhitePanel(stage) {
    if (!qrBackingVisible()) {
      whitePanel?.remove();
      whitePanel = null;
      currentStage = stage;
      return;
    }

    if (
      whitePanel?.isConnected &&
      currentStage === stage
    ) {
      whitePanel.style.setProperty(
        'background',
        qrBackingColor(),
        'important'
      );
      return;
    }

    whitePanel?.remove();

    whitePanel =
      document.createElement('div');

    whitePanel.dataset
      .smoofQrWhitePanel = 'true';

    whitePanel.setAttribute(
      'aria-hidden',
      'true'
    );

    whitePanel.style.setProperty(
      'background',
      qrBackingColor(),
      'important'
    );

    stage.appendChild(whitePanel);
    currentStage = stage;
  }

  function createQrPlaceholder(
    stage
  ) {
    const placeholder =
      document.createElement('div');

    placeholder.dataset
      .smoofProofQrPlaceholder =
      'true';

    placeholder.setAttribute(
      'aria-hidden',
      'true'
    );

    const inner =
      document.createElement('div');

    inner.dataset
      .smoofProofQrPlaceholderInner =
      'true';

    inner.innerHTML =
      'QR-CODE<br>PLACEHOLDER';

    placeholder.appendChild(inner);
    stage.appendChild(placeholder);

    return placeholder;
  }

  function captureFilter(node) {
    if (!(node instanceof Element)) {
      return true;
    }

    /*
     * Easify/Konva zeichnet die ursprüngliche
     * Vorschau auf mehreren Canvas-Ebenen.
     * html-to-image klont jedes Canvas intern
     * ausschließlich über toDataURL(). Einige
     * von Safari/Konva bereitgestellte Canvas-
     * Objekte besitzen diese Methode nicht.
     *
     * Für den Proof werden diese Ebenen nicht
     * benötigt: Hintergrund, Texte, Pfeile,
     * Logo, QR-Weißfläche und QR-Platzhalter
     * entstehen in unseren eigenen DOM-Ebenen.
     */
    if (
      node.tagName === 'CANVAS'
    ) {
      return false;
    }

    return !node.matches(
      [
        '[data-smoof-guide-overlay]',
        '[data-smoof-surface-overlay]',
        '[data-smoof-product-shadow]',
        '[data-smoof-background-hit]',
        '[data-smoof-background-controls]',
        '[data-smoof-arrow-controls]',
        '[data-smoof-arrow-selection-frame]',
        '[data-smoof-text-controls]',
        '[data-smoof-logo-controls]',
        '[data-smoof-number-controls]',
        '[data-smoof-brand-controls]',
        '[data-smoof-mobile-text-toolbar]',
        '[data-smoof-mobile-text-dock]',
        '[data-smoof-number-mobile-toolbar]',
        '[data-smoof-brand-mobile-toolbar]',
        '[data-smoof-text-snap-guide]',
        '[data-smoof-number-snap-guide]',
        '[data-smoof-snap-guide]',
        '[data-smoof-text-hidden-marker]'
      ].join(',')
    );
  }

  function createProofStageClone(
    stage
  ) {
    const stageRect =
      stage.getBoundingClientRect();

    /*
     * Native cloneNode() kopiert die DOM-
     * Struktur ohne Easifys Canvas-Inhalt
     * auszulesen. Anschließend entfernen
     * wir sämtliche Konva-Canvas-Ebenen
     * aus der Kopie, bevor html2canvas
     * sie verarbeitet.
     */
    const captureStage =
      stage.cloneNode(true);

    captureStage
      .querySelectorAll('canvas')
      .forEach(canvas => {
        canvas.remove();
      });

    captureStage.dataset
      .smoofProofCaptureStage =
      'true';

    Object.assign(
      captureStage.style,
      {
        position: 'fixed',
        left: '0',
        top: '0',
        width:
          `${stageRect.width}px`,
        height:
          `${stageRect.height}px`,
        maxWidth: 'none',
        maxHeight: 'none',
        margin: '0',
        transform: 'none',
        pointerEvents: 'none',
        zIndex: '-2147483647'
      }
    );

    document.body.appendChild(
      captureStage
    );

    return captureStage;
  }

  async function getColoredArrowSvg(
    url,
    color,
    isLabel
  ) {
    const cacheKey =
      [
        url,
        color,
        isLabel
          ? 'label'
          : 'arrow'
      ].join('|');

    if (
      proofArrowSvgCache.has(
        cacheKey
      )
    ) {
      return proofArrowSvgCache.get(
        cacheKey
      );
    }

    const request =
      fetch(url, {
        credentials: 'omit'
      }).then(async response => {
        if (!response.ok) {
          throw new Error(
            `Arrow SVG ${response.status}`
          );
        }

        const source =
          await response.text();

        const svgDocument =
          new DOMParser()
            .parseFromString(
              source,
              'image/svg+xml'
            );

        const svg =
          svgDocument.documentElement;

        if (
          svg.tagName.toLowerCase() !==
            'svg'
        ) {
          throw new Error(
            'Invalid arrow SVG'
          );
        }

        const viewBox =
          String(
            svg.getAttribute(
              'viewBox'
            ) || ''
          )
            .trim()
            .split(
              /[\s,]+/
            )
            .map(Number);

        if (
          viewBox.length === 4 &&
          viewBox.every(
            Number.isFinite
          ) &&
          viewBox[2] > 0 &&
          viewBox[3] > 0
        ) {
          const [
            x,
            y,
            width,
            height
          ] = viewBox;

          const cropY =
            isLabel
              ? y + height * 0.8
              : y;

          const cropHeight =
            height *
            (
              isLabel
                ? 0.2
                : 0.81
            );

          svg.setAttribute(
            'viewBox',
            [
              x,
              cropY,
              width,
              cropHeight
            ].join(' ')
          );
        }

        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.setAttribute(
          'preserveAspectRatio',
          'none'
        );

        svg.setAttribute(
          'fill',
          color
        );

        svg
          .querySelectorAll(
            '[fill]'
          )
          .forEach(element => {
            if (
              element.getAttribute(
                'fill'
              ) !== 'none'
            ) {
              element.setAttribute(
                'fill',
                color
              );
            }
          });

        const style =
          svgDocument.createElementNS(
            'http://www.w3.org/2000/svg',
            'style'
          );

        style.textContent =
          `path, circle, ellipse, rect, polygon, polyline, text, tspan { fill: ${color} !important; }`;

        svg.insertBefore(
          style,
          svg.firstChild
        );

        const serialized =
          new XMLSerializer()
            .serializeToString(svg);

        return (
          'data:image/svg+xml;charset=utf-8,' +
          encodeURIComponent(
            serialized
          )
        );
      });

    proofArrowSvgCache.set(
      cacheKey,
      request
    );

    return request;
  }

  function replaceArrowMaskWithImage(
    element,
    source
  ) {
    element.replaceChildren();

    Object.assign(
      element.style,
      {
        backgroundColor:
          'transparent',
        maskImage: 'none',
        webkitMaskImage: 'none',
        clipPath: 'none',
        WebkitClipPath: 'none',
        overflow: 'hidden'
      }
    );

    const image =
      document.createElement('img');

    image.alt = '';
    image.src = source;

    Object.assign(
      image.style,
      {
        position: 'absolute',
        inset: '0',
        left: '0',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        maxHeight: 'none',
        objectFit: 'fill',
        display: 'block',
        pointerEvents: 'none'
      }
    );

    element.appendChild(image);
  }

  async function prepareProofStage(
    captureStage
  ) {
    /*
     * html2canvas unterstützt die in der
     * Live-Vorschau eingesetzten CSS-Masks
     * und clip-path-Kreise nicht vollständig.
     * Für den Proof verwenden wir daher
     * exportfreundliche Entsprechungen.
     */
    captureStage
      .querySelectorAll(
        '[data-smoof-background-color]'
      )
      .forEach(layer => {
        Object.assign(
          layer.style,
          {
            inset: 'auto',
            left: '14.66%',
            top: '14.66%',
            width: '70.68%',
            height: '70.68%',
            clipPath: 'none',
            WebkitClipPath: 'none',
            borderRadius: '50%',
            overflow: 'hidden'
          }
        );
      });

    const arrowElements =
      Array.from(
        captureStage.querySelectorAll(
          [
            '[data-smoof-arrow-graphic]',
            '[data-smoof-arrow-label-graphic]'
          ].join(',')
        )
      );

    await Promise.all(
      arrowElements.map(
        async element => {
          const side =
            element.dataset
              .smoofArrowGraphic ||
            element.dataset
              .smoofArrowLabelGraphic;

          const url =
            PROOF_ARROW_URLS[side];

          if (!url) return;

          const color =
            element.style
              .backgroundColor ||
            '#000000';

          let source = url;
          const isLabel =
            Boolean(
              element.dataset
                .smoofArrowLabelGraphic
            );

          try {
            source =
              await getColoredArrowSvg(
                url,
                color,
                isLabel
              );
          } catch (error) {
            console.warn(
              'SMOOF arrow proof fallback',
              error
            );
          }

          replaceArrowMaskWithImage(
            element,
            source
          );
        }
      )
    );
  }

  async function captureArtwork(
    diameter,
    suppliedModel = null
  ) {
    const renderer =
      window.SmoofDesignRenderer;

    if (
      !renderer ||
      renderer.build !==
        REQUIRED_RENDERER_BUILD ||
      typeof renderer.renderPng !==
        'function' ||
      typeof renderer.readModel !==
        'function'
    ) {
      throw new Error(
        'SVG design renderer unavailable'
      );
    }

    /*
     * Der vollständige Editorzustand wird vor Blur und Deselektion gesichert.
     * So kann das Schließen eines Kontextfensters weder NFC-Sichtbarkeit noch
     * Farben oder Positionen während des Exports verändern.
     */
    const model =
      suppliedModel ||
      renderer.readModel();

    document.activeElement?.blur?.();

    window.dispatchEvent(
      new CustomEvent(
        'smoof:editor-select',
        {
          detail: {
            id: ''
          }
        }
      )
    );

    await document.fonts?.ready;
    await delay(120);

    /*
     * Ein einziger verbindlicher Export. QR und NFC sind Bestandteile dieses
     * Renderdurchlaufs und werden danach nicht nochmals überzeichnet.
     */
    return renderer.renderPng({
      diameter,
      model
    });
  }

  function drawInfoRow(
    doc,
    label,
    value,
    y
  ) {
    doc.setFont(
      'helvetica',
      'bold'
    );
    doc.setFontSize(9);
    doc.setTextColor(
      80,
      80,
      80
    );
    doc.text(
      label,
      22,
      y
    );

    doc.setFont(
      'helvetica',
      'normal'
    );
    doc.setTextColor(
      20,
      20,
      20
    );
    doc.text(
      value,
      66,
      y
    );
  }

  function richTextLines(
    doc,
    segments,
    maximumWidth
  ) {
    const lines = [[]];
    let lineWidth = 0;

    segments.forEach(segment => {
      const style =
        segment.bold
          ? 'bold'
          : 'normal';

      String(segment.text)
        .split(/(\s+)/)
        .filter(Boolean)
        .forEach(token => {
          const isSpace =
            /^\s+$/.test(token);

          if (
            isSpace &&
            lineWidth === 0
          ) {
            return;
          }

          const text =
            isSpace
              ? ' '
              : token;

          doc.setFont(
            'helvetica',
            style
          );

          const width =
            doc.getTextWidth(text);

          if (
            !isSpace &&
            lineWidth > 0 &&
            lineWidth + width >
              maximumWidth
          ) {
            lines.push([]);
            lineWidth = 0;
          }

          if (
            isSpace &&
            lineWidth + width >
              maximumWidth
          ) {
            lines.push([]);
            lineWidth = 0;
            return;
          }

          lines[
            lines.length - 1
          ].push({
            text,
            style,
            width
          });

          lineWidth += width;
        });
    });

    return lines.filter(
      line => line.length
    );
  }

  function drawRichTextBlock(
    doc,
    segments,
    x,
    y,
    maximumWidth,
    lineHeight
  ) {
    const lines =
      richTextLines(
        doc,
        segments,
        maximumWidth
      );

    lines.forEach(
      (line, lineIndex) => {
        let cursor = x;

        line.forEach(run => {
          doc.setFont(
            'helvetica',
            run.style
          );

          doc.text(
            run.text,
            cursor,
            y +
              lineIndex *
              lineHeight
          );

          cursor += run.width;
        });
      }
    );

    return lines.length;
  }

  function buildProofPdf(
    jsPDF,
    artworkBytes,
    diameter,
    proofId,
    brandLogo,
    surface = 'front',
    qr = null
  ) {
    const doc =
      new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        compress: true
      });

    const pageWidth =
      doc.internal.pageSize
        .getWidth();

    const productTitle =
      getProductTitle();

    const createdAt =
      new Intl.DateTimeFormat(
        'de-DE',
        {
          dateStyle: 'short',
          timeStyle: 'short'
        }
      ).format(new Date());

    doc.setProperties({
      title:
        `SMOOF Proof ${proofId}`,
      subject:
        'Automatisch erzeugter Korrekturabzug / Automatically generated design proof',
      author: 'SMOOF',
      creator:
        `SMOOF Editor ${VERSION}`,
      keywords:
        'SMOOF, proof, Shopify'
    });

    doc.setFillColor(
      19,
      19,
      19
    );
    doc.rect(
      0,
      0,
      pageWidth,
      30,
      'F'
    );

    doc.addImage(
      brandLogo,
      'PNG',
      18,
      7.9,
      35,
      14.2,
      undefined,
      'FAST'
    );

    doc.setTextColor(
      255,
      255,
      255
    );
    doc.setFont(
      'helvetica',
      'bold'
    );
    doc.setFontSize(12);
    doc.text(
      'KORREKTURABZUG / DESIGN PROOF',
      pageWidth - 18,
      18,
      {
        align: 'right'
      }
    );

    doc.setFillColor(
      255,
      235,
      231
    );
    doc.roundedRect(
      18,
      36,
      pageWidth - 36,
      10,
      2,
      2,
      'F'
    );

    doc.setTextColor(
      173,
      45,
      22
    );
    doc.setFontSize(9);
    const proofHasQr = qrVisible({ qr: qr || {} });

    doc.text(
      proofHasQr
        ? 'NICHT FÜR DIE PRODUKTION / NOT FOR PRODUCTION · QR-CODE-PLATZHALTER / QR CODE PLACEHOLDER'
        : 'NICHT FÜR DIE PRODUKTION / NOT FOR PRODUCTION · KEIN QR-CODE / NO QR CODE',
      pageWidth / 2,
      42.5,
      {
        align: 'center'
      }
    );

    const artworkSize = 128;
    const artworkX =
      (
        pageWidth -
        artworkSize
      ) / 2;

    doc.setDrawColor(
      225,
      225,
      225
    );
    doc.setLineWidth(0.3);
    doc.rect(
      artworkX - 1,
      51,
      artworkSize + 2,
      artworkSize + 2
    );

    doc.addImage(
      artworkBytes,
      'PNG',
      artworkX,
      52,
      artworkSize,
      artworkSize,
      undefined,
      'FAST'
    );

    doc.setFillColor(
      247,
      247,
      247
    );
    doc.roundedRect(
      18,
      187,
      pageWidth - 36,
      43,
      3,
      3,
      'F'
    );

    const surfaceLabel = surface === 'back'
      ? 'Rückseite / Back'
      : 'Vorderseite / Front';

    drawInfoRow(
      doc,
      'Produkt / Product',
      productTitle.slice(0, 64),
      193
    );

    drawInfoRow(
      doc,
      'Seite / Surface',
      surfaceLabel,
      200
    );

    drawInfoRow(
      doc,
      'Druckformat / Print format',
      `Ø ${diameter} mm`,
      207
    );

    drawInfoRow(
      doc,
      'Proof-ID / Proof ID',
      proofId,
      214
    );

    drawInfoRow(
      doc,
      'Erstellt / Created',
      createdAt,
      221
    );

    doc.setFont(
      'helvetica',
      'bold'
    );
    doc.setFontSize(10);
    doc.setTextColor(
      20,
      20,
      20
    );

    doc.text(
      'Hinweise zur Freigabe / Approval notes',
      18,
      242
    );

    doc.setFont(
      'helvetica',
      'normal'
    );
    doc.setFontSize(7.2);
    doc.setTextColor(
      70,
      70,
      70
    );

    const notesDe = [
      {
        text:
          'Bitte prüfen Sie Texte, Farben, Logo, Positionen und Größen sorgfältig. ',
        bold: false
      },
      proofHasQr
        ? {
            text:
              'Der im Proof dargestellte QR-Code ist lediglich ein Platzhalter. Die korrekten QR-Codes werden erst bei der finalen Erstellung der Druckdaten unmittelbar vor der Produktion eingesetzt.',
            bold: false
          }
        : {
            text:
              'Für dieses Design ist kein QR-Code vorgesehen; bei der finalen Erstellung der Druckdaten darf kein QR-Code ergänzt werden.',
            bold: false
          },
      {
        text:
          ' Sofern variable Tisch- oder Zimmernummern verwendet werden, werden diese in diesem Proof exemplarisch dargestellt. Bildschirmfarben können von den gedruckten Farben abweichen.',
        bold: false
      }
    ];

    const notesEn = [
      {
        text:
          'Please check all text, colors, logos, positions and sizes carefully. ',
        bold: false
      },
      proofHasQr
        ? {
            text:
              'The QR code shown in this proof is for placeholder purposes only. The correct QR codes will only be inserted during the final preparation of the print files, immediately before production.',
            bold: false
          }
        : {
            text:
              'No QR code is intended for this design; no QR code may be added during final print-file preparation.',
            bold: false
          },
      {
        text:
          ' If variable table or room numbers are used, they are shown as examples in this proof. Screen colors may differ from printed colors.',
        bold: false
      }
    ];

    const noteWidth =
      pageWidth - 49;

    const noteLineHeight = 3.05;

    doc.setFont(
      'helvetica',
      'bold'
    );

    doc.setTextColor(
      229,
      0,
      125
    );

    doc.text(
      'DE',
      18,
      249
    );

    doc.setTextColor(
      70,
      70,
      70
    );

    const notesDeLineCount =
      drawRichTextBlock(
        doc,
        notesDe,
        27,
        249,
        noteWidth,
        noteLineHeight
      );

    const englishY =
      249 +
      notesDeLineCount *
      noteLineHeight +
      1.5;

    doc.setFont(
      'helvetica',
      'bold'
    );

    doc.setTextColor(
      229,
      0,
      125
    );

    doc.text(
      'EN',
      18,
      englishY
    );

    doc.setTextColor(
      70,
      70,
      70
    );

    drawRichTextBlock(
      doc,
      notesEn,
      27,
      englishY,
      noteWidth,
      noteLineHeight
    );

    doc.setDrawColor(
      220,
      220,
      220
    );
    doc.line(
      18,
      281,
      pageWidth - 18,
      281
    );

    doc.setFontSize(7.5);
    doc.setTextColor(
      130,
      130,
      130
    );

    doc.text(
      `SMOOF · ${proofId} · ${VERSION} · ${REQUIRED_RENDERER_BUILD}`,
      18,
      287
    );

    doc.text(
      'smoofdots.com',
      pageWidth - 18,
      287,
      {
        align: 'right'
      }
    );

    return doc.output('blob');
  }

  function buildProductionPdf(
    jsPDF,
    productionResult,
    productionId
  ) {
    const pageSizeMm =
      Number(
        productionResult
          .pageSizeMm
      );

    if (
      !Number.isFinite(pageSizeMm) ||
      pageSizeMm <= 0
    ) {
      throw new Error(
        'Invalid production page size'
      );
    }

    const doc =
      new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [
          pageSizeMm,
          pageSizeMm
        ],
        compress: true,
        putOnlyUsedFonts: true
      });

    doc.setProperties({
      title:
        `SMOOF Production ${productionId}`,
      subject:
        [
          `Trim Ø ${productionResult.trimDiameterMm} mm`,
          `Bleed ${productionResult.bleedMm} mm`,
          `${productionResult.dpi} dpi`
        ].join(' · '),
      author: 'SMOOF',
      creator:
        'SMOOF Design Renderer'
    });

    doc.addImage(
      productionResult.bytes,
      'PNG',
      0,
      0,
      pageSizeMm,
      pageSizeMm,
      undefined,
      'FAST'
    );

    return doc.output('blob');
  }

  function sanitizeFileName(value) {
    return String(value)
      .normalize('NFKD')
      .replace(
        /[\u0300-\u036f]/g,
        ''
      )
      .replace(
        /[^a-z0-9_-]+/gi,
        '-'
      )
      .replace(
        /^[-_]+|[-_]+$/g,
        ''
      )
      .slice(0, 70) ||
      'SMOOF';
  }

  function setProperty(
    form,
    name,
    value
  ) {
    let input =
      Array.from(
        form.querySelectorAll(
          'input'
        )
      ).find(candidate =>
        candidate.name === name &&
        candidate.type !== 'file'
      );

    if (!input) {
      input =
        document.createElement(
          'input'
        );

      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function getFileInput(
    form,
    name
  ) {
    let input =
      form.querySelector(
        `input[type="file"][name="${name}"]`
      );

    if (!input) {
      input =
        document.createElement(
          'input'
        );

      input.type = 'file';
      input.name = name;
      input.hidden = true;
      input.dataset.smoofGeneratedFile = 'true';
      form.appendChild(input);
    }

    input.dataset.smoofGeneratedFile = 'true';

    return input;
  }

  function surfaceLabel(surface) {
    return surface === 'back'
      ? 'Rückseite'
      : 'Vorderseite';
  }

  function proofInputName(surface, surfaceCount) {
    return surfaceCount > 1
      ? `properties[SMOOF Proof ${surfaceLabel(surface)}]`
      : PREVIEW_INPUT_NAME;
  }

  function productionInputName(
    surface,
    surfaceCount,
    vectorOnly = false
  ) {
    return surfaceCount > 1
      ? `properties[SMOOF Produktionsvorlage ${surfaceLabel(surface)}]`
      : vectorOnly
        ? 'properties[SMOOF Laserdatei]'
        : PRODUCTION_INPUT_NAME;
  }

  function clearGeneratedFileInputs(form) {
    form.querySelectorAll('[data-smoof-generated-file="true"]')
      .forEach(input => input.remove());
  }

  function attachFileToInput(
    form,
    name,
    file
  ) {
    if (
      typeof DataTransfer !==
      'function'
    ) {
      throw new Error(
        'File attachment unavailable'
      );
    }

    const transfer =
      new DataTransfer();

    transfer.items.add(file);

    const input =
      getFileInput(
        form,
        name
      );

    input.files =
      transfer.files;

    input.dispatchEvent(
      new Event(
        'input',
        {
          bubbles: true
        }
      )
    );

    input.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );

    form.enctype =
      'multipart/form-data';
  }

  async function createCartPreviewFile(
    artworkBytes,
    previewId,
    surface = 'front',
    surfaceCount = 1
  ) {
    let previewBytes =
      artworkBytes;

    const productView =
      document.smoofCartPreviewCompositor ||
      window.SmoofCartPreviewCompositor ||
      window.SmoofProductView;

    if (
      productView &&
      typeof productView
        .renderCartPreview ===
        'function'
    ) {
      document.documentElement.dataset
        .smoofCartPreviewAdapter =
        String(productView.version || 'legacy');
      try {
        previewBytes =
          await productView
            .renderCartPreview(
              artworkBytes,
              { surface, surfaceCount }
            );
      } catch (error) {
        /*
         * Der Bestellvorgang darf bei einem
         * reinen Produktbildfehler nicht
         * blockiert werden. Proof und
         * Produktionsdatei bleiben gültig.
         */
        console.warn(
          'SMOOF product cart preview failed',
          error
        );
      }
    }

    return new File(
      [previewBytes],
      [
        'SMOOF-Warenkorb-Vorschau',
        previewId,
        surfaceCount > 1
          ? surfaceLabel(surface)
          : ''
      ].filter(Boolean).join('-') + '.png',
      {
        type: 'image/png',
        lastModified: Date.now()
      }
    );
  }

  function attachCartPreviewToForm(
    form,
    previews
  ) {
    cartPreviewFiles.set(
      form,
      previews
    );

    if (
      form.dataset
        .smoofCartPreviewListener
    ) {
      return;
    }

    form.dataset
      .smoofCartPreviewListener =
      'true';

    form.addEventListener(
      'formdata',
      event => {
        const currentFiles =
          cartPreviewFiles.get(
            form
          );

        if (!currentFiles?.length) return;

        currentFiles.forEach(preview => {
          event.formData.set(
            preview.name,
            preview.file,
            preview.file.name
          );
        });
      }
    );
  }

  function attachProofToForm(
    form,
    proofFile,
    proofId,
    diameter,
    surface = 'front',
    surfaceCount = 1,
    qr = null
  ) {
    attachFileToInput(
      form,
      proofInputName(
        surface,
        surfaceCount
      ),
      proofFile
    );

    setProperty(
      form,
      'properties[_SMOOF Proof Version]',
      VERSION
    );

    setProperty(
      form,
      'properties[_SMOOF Proof ID]',
      proofId
    );

    setProperty(
      form,
      'properties[_SMOOF Proof Format]',
      `Ø ${diameter} mm`
    );

    setProperty(
      form,
      'properties[_SMOOF Proof QR]',
      qrVisible({ qr: qr || {} })
        ? 'Platzhalter'
        : 'Kein QR-Code'
    );

    setQrProperties(form, qr, surface, surfaceCount);
  }

  function qrPropertySuffix(surface, surfaceCount) {
    if (surfaceCount < 2) return '';
    return surface === 'back' ? ' Rückseite' : ' Vorderseite';
  }

  function setQrProperties(form, qr, surface, surfaceCount) {
    const state = qrState({ qr: qr || {} });
    const suffix = qrPropertySuffix(surface, surfaceCount);

    setProperty(
      form,
      `properties[_SMOOF QR sichtbar${suffix}]`,
      state.visible ? 'Ja' : 'Nein'
    );
    setProperty(
      form,
      `properties[_SMOOF QR Hintergrund sichtbar${suffix}]`,
      qrBackingVisible({ qr: state }) ? 'Ja' : 'Nein'
    );
    setProperty(
      form,
      `properties[_SMOOF QR Hintergrund Farbe${suffix}]`,
      qrBackingColor({ qr: state })
    );
    setProperty(
      form,
      `properties[_SMOOF QR Farbe${suffix}]`,
      qrCodeColor({ qr: state })
    );
  }

  function attachProductionToForm(
    form,
    productionFile,
    productionId,
    productionResult,
    surface = 'front',
    surfaceCount = 1
  ) {
    attachFileToInput(
      form,
      productionInputName(
        surface,
        surfaceCount,
        productionResult.vectorOnly
      ),
      productionFile
    );

    setProperty(
      form,
      'properties[_SMOOF Production Version]',
      VERSION
    );

    setProperty(
      form,
      'properties[_SMOOF Production ID]',
      productionId
    );

    setProperty(
      form,
      'properties[_SMOOF Production Trim]',
      `Ø ${productionResult.trimDiameterMm} mm`
    );

    setProperty(
      form,
      'properties[_SMOOF Production Format]',
      `${productionResult.pageSizeMm} × ${productionResult.pageSizeMm} mm`
    );

    setProperty(
      form,
      'properties[_SMOOF Production Bleed]',
      productionResult.vectorOnly
        ? 'Kein Beschnitt (Lasergravur)'
        : `${productionResult.bleedMm} mm umlaufend`
    );

    setProperty(
      form,
      'properties[_SMOOF Production Resolution]',
      productionResult.vectorOnly
        ? '100 % Vektor / Pfade'
        : `${productionResult.dpi} dpi`
    );

    setProperty(
      form,
      'properties[_SMOOF Production Type]',
      productionResult.vectorOnly
        ? 'Laser SVG (vollständig vektorbasiert)'
        : 'Druck-PDF'
    );

    setProperty(
      form,
      'properties[_SMOOF Production QR]',
      productionResult.qr?.visible === false
        ? 'Kein QR-Code vorgesehen'
        : productionResult.vectorOnly
          ? 'Vektor-Sperrzone – finaler QR-Code fehlt'
          : productionResult.qr?.backingVisible === false
            ? 'QR-Platzhalter ohne Hintergrundfläche'
            : 'QR-Platzhalter mit Hintergrundfläche'
    );

    setQrProperties(
      form,
      productionResult.qr,
      surface,
      surfaceCount
    );
  }

  function ensureStatusOverlay() {
    if (
      statusOverlay?.isConnected
    ) {
      return statusOverlay;
    }

    statusOverlay =
      document.createElement('div');

    statusOverlay.dataset
      .smoofProofStatus = 'true';

    statusOverlay.hidden = true;

    const card =
      document.createElement('div');

    card.dataset
      .smoofProofStatusCard =
      'true';

    const spinner =
      document.createElement('div');

    spinner.dataset
      .smoofProofSpinner = 'true';

    const title =
      document.createElement('div');

    title.dataset
      .smoofProofStatusTitle =
      'true';

    const copy =
      document.createElement('div');

    copy.dataset
      .smoofProofStatusCopy =
      'true';

    const close =
      document.createElement(
        'button'
      );

    close.type = 'button';
    close.dataset
      .smoofProofStatusClose =
      'true';

    close.textContent =
      text('Schließen', 'Close');

    close.hidden = true;

    close.addEventListener(
      'click',
      () => {
        statusOverlay.hidden = true;
      }
    );

    card.append(
      spinner,
      title,
      copy,
      close
    );

    statusOverlay.appendChild(card);
    document.body.appendChild(
      statusOverlay
    );

    return statusOverlay;
  }

  function showWorkingStatus() {
    const overlay =
      ensureStatusOverlay();

    overlay.dataset.state =
      'working';

    overlay.querySelector(
      '[data-smoof-proof-status-title]'
    ).textContent =
      text(
        'PDF-Dateien werden erstellt',
        'Creating PDF files'
      );

    overlay.querySelector(
      '[data-smoof-proof-status-copy]'
    ).textContent =
      text(
        'Proof und Produktionsvorlage werden erzeugt und anschließend an den Warenkorb angehängt.',
        'The proof and production template are being created and will then be attached to the cart.'
      );

    overlay.querySelector(
      '[data-smoof-proof-status-close]'
    ).hidden = true;

    overlay.hidden = false;
  }

  function showErrorStatus(error) {
    const overlay =
      ensureStatusOverlay();

    overlay.dataset.state =
      'error';

    overlay.querySelector(
      '[data-smoof-proof-status-title]'
    ).textContent =
      text(
        'Produktionsdateien konnten nicht erstellt werden',
        'The production files could not be created'
      );

    const technicalDetail =
      error instanceof Error
        ? error.message
        : String(
          error?.type ||
          error ||
          ''
        );

    overlay.querySelector(
      '[data-smoof-proof-status-copy]'
    ).textContent = [
      text(
        'Proof oder Produktionsdatei konnten nicht sicher erzeugt werden. Das Produkt wurde nicht in den Warenkorb gelegt. Bitte schließen Sie dieses Fenster und versuchen Sie es erneut.',
        'The product has not been added to the cart. Please close this message and try again.'
      ),
      technicalDetail
        ? text(
            `Technischer Hinweis: ${technicalDetail}`,
            `Technical detail: ${technicalDetail}`
          )
        : ''
    ].filter(Boolean).join(' ');

    overlay.querySelector(
      '[data-smoof-proof-status-close]'
    ).hidden = false;

    overlay.hidden = false;

    console.error(
      'SMOOF proof generation failed',
      error
    );
  }

  function hideStatus() {
    if (statusOverlay) {
      statusOverlay.hidden = true;
    }
  }

  async function createProofFile(
    proofId = createProofId(),
    {
      surface = 'front',
      model = null
    } = {}
  ) {
    const {
      jsPDF
    } = await loadDependencies();

    const diameter =
      getPrintDiameterMm();

    const brandLogo =
      await brandLogoPng();

    let artworkBytes;

    try {
      artworkBytes =
        await captureArtwork(
          diameter,
          model
        );
    } catch (error) {
      throw new Error(
        `Vorschau-Erfassung: ${
          error instanceof Error
            ? error.message
            : String(error)
        }`
      );
    }

    let pdfBlob;
    const qr = qrState(model);

    try {
      pdfBlob =
        buildProofPdf(
          jsPDF,
          artworkBytes,
          diameter,
          proofId,
          brandLogo,
          surface,
          qr
        );
    } catch (error) {
      throw new Error(
        `PDF-Erzeugung: ${
          error instanceof Error
            ? error.message
            : String(error)
        }`
      );
    }

    const fileName =
      `${surface === 'back' ? 'back' : 'front'}.pdf`;

    return {
      file:
        new File(
          [pdfBlob],
          fileName,
          {
            type:
              'application/pdf',
            lastModified:
              Date.now()
          }
        ),
      proofId,
      diameter,
      artworkBytes,
      surface,
      qr
    };
  }

  async function createProductionFile(
    productionId =
      createProofId(),
    {
      surface = 'front',
      model = null
    } = {}
  ) {
    const diameter =
      getPrintDiameterMm();

    const renderer =
      window.SmoofDesignRenderer;

    if (
      !renderer ||
      renderer.build !==
        REQUIRED_RENDERER_BUILD ||
      typeof renderer
        .renderProductionPng !==
        'function' ||
      typeof renderer
        .renderLaserSvg !==
        'function' ||
      typeof renderer.readModel !==
        'function'
    ) {
      throw new Error(
        'Production renderer unavailable'
      );
    }

    const productionModel =
      model ||
      renderer.readModel();

    document.activeElement
      ?.blur?.();

    window.dispatchEvent(
      new CustomEvent(
        'smoof:editor-select',
        {
          detail: {
            id: ''
          }
        }
      )
    );

    await document.fonts?.ready;
    await delay(120);

    const laser =
      productionModel
        ?.productVariant
        ?.printProcess ===
        'laser';

    let productionResult;
    let productionBlob;
    let extension;
    let mimeType;

    if (laser) {
      productionResult =
        await renderer.renderLaserSvg({
          diameter,
          model: productionModel,
          surface
        });
      productionBlob = new Blob(
        [productionResult.bytes],
        {
          type:
            'image/svg+xml;charset=utf-8'
        }
      );
      extension = 'svg';
      mimeType = 'image/svg+xml';
    } else {
      const {
        jsPDF
      } = await loadDependencies();

      productionResult =
        await renderer
          .renderProductionPng({
            diameter,
            bleedMm:
              PRODUCTION_BLEED_MM,
            dpi:
              PRODUCTION_DPI,
            model: productionModel
          });

      productionBlob =
        buildProductionPdf(
          jsPDF,
          productionResult,
          productionId
        );
      extension = 'pdf';
      mimeType = 'application/pdf';
    }

    const fileName =
      `${surface === 'back' ? 'back' : 'front'}.${extension}`;

    return {
      file:
        new File(
          [productionBlob],
          fileName,
          {
            type: mimeType,
            lastModified:
              Date.now()
          }
        ),
      productionId,
      productionResult,
      surface
    };
  }

  function downloadFile(file) {
    const url =
      URL.createObjectURL(file);

    const link =
      document.createElement('a');

    link.href = url;
    link.download = file.name;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(
      () => {
        URL.revokeObjectURL(url);
      },
      1500
    );
  }

  let zipCrcTable = null;

  function crc32(bytes) {
    if (!zipCrcTable) {
      zipCrcTable = new Uint32Array(256);
      for (let index = 0; index < 256; index += 1) {
        let value = index;
        for (let bit = 0; bit < 8; bit += 1) {
          value = (value & 1)
            ? 0xedb88320 ^ (value >>> 1)
            : value >>> 1;
        }
        zipCrcTable[index] = value >>> 0;
      }
    }

    let crc = 0xffffffff;
    bytes.forEach(byte => {
      crc = zipCrcTable[(crc ^ byte) & 0xff] ^ (crc >>> 8);
    });
    return (crc ^ 0xffffffff) >>> 0;
  }

  function dosDateTime(date = new Date()) {
    const year = Math.max(1980, date.getFullYear());
    return {
      time:
        (date.getHours() << 11) |
        (date.getMinutes() << 5) |
        Math.floor(date.getSeconds() / 2),
      date:
        ((year - 1980) << 9) |
        ((date.getMonth() + 1) << 5) |
        date.getDate()
    };
  }

  function zipHeader(length, write) {
    const bytes = new Uint8Array(length);
    write(new DataView(bytes.buffer));
    return bytes;
  }

  async function createStoredZip(files, fileName) {
    const encoder = new TextEncoder();
    const parts = [];
    const centralParts = [];
    let offset = 0;

    for (const file of files) {
      const name = encoder.encode(file.name);
      const data = new Uint8Array(await file.arrayBuffer());
      const checksum = crc32(data);
      const stamp = dosDateTime(new Date(file.lastModified || Date.now()));

      const local = zipHeader(30, view => {
        view.setUint32(0, 0x04034b50, true);
        view.setUint16(4, 20, true);
        view.setUint16(6, 0x0800, true);
        view.setUint16(8, 0, true);
        view.setUint16(10, stamp.time, true);
        view.setUint16(12, stamp.date, true);
        view.setUint32(14, checksum, true);
        view.setUint32(18, data.length, true);
        view.setUint32(22, data.length, true);
        view.setUint16(26, name.length, true);
        view.setUint16(28, 0, true);
      });

      const central = zipHeader(46, view => {
        view.setUint32(0, 0x02014b50, true);
        view.setUint16(4, 20, true);
        view.setUint16(6, 20, true);
        view.setUint16(8, 0x0800, true);
        view.setUint16(10, 0, true);
        view.setUint16(12, stamp.time, true);
        view.setUint16(14, stamp.date, true);
        view.setUint32(16, checksum, true);
        view.setUint32(20, data.length, true);
        view.setUint32(24, data.length, true);
        view.setUint16(28, name.length, true);
        view.setUint16(30, 0, true);
        view.setUint16(32, 0, true);
        view.setUint16(34, 0, true);
        view.setUint16(36, 0, true);
        view.setUint32(38, 0, true);
        view.setUint32(42, offset, true);
      });

      parts.push(local, name, data);
      centralParts.push(central, name);
      offset += local.length + name.length + data.length;
    }

    const centralOffset = offset;
    const centralSize = centralParts.reduce((sum, part) => sum + part.length, 0);
    const end = zipHeader(22, view => {
      view.setUint32(0, 0x06054b50, true);
      view.setUint16(4, 0, true);
      view.setUint16(6, 0, true);
      view.setUint16(8, files.length, true);
      view.setUint16(10, files.length, true);
      view.setUint32(12, centralSize, true);
      view.setUint32(16, centralOffset, true);
      view.setUint16(20, 0, true);
    });

    return new File(
      [...parts, ...centralParts, end],
      fileName,
      {
        type: 'application/zip',
        lastModified: Date.now()
      }
    );
  }

  async function createDownloadBundle(results, bundleName) {
    const files = results.map(result => result.file);
    return files.length > 1
      ? createStoredZip(files, bundleName)
      : files[0];
  }

  async function activateSurface(
    store,
    surface
  ) {
    for (let attempt = 0; attempt < 8; attempt += 1) {
      if (store.getActive() === surface) return;
      if (store.switchTo(surface, 'export')) {
        await delay(340);
        if (store.getActive() === surface) return;
      }
      await delay(90);
    }

    throw new Error(
      `Designfläche „${surfaceLabel(surface)}“ konnte nicht aktiviert werden.`
    );
  }

  async function captureSurfaceModels() {
    const renderer =
      window.SmoofDesignRenderer;
    const store =
      window.SmoofSurfaceStore;
    const surfaces =
      Array.isArray(store?.surfaces) &&
      store.surfaces.length
        ? [...store.surfaces]
        : ['front'];
    const originalSurface =
      store?.getActive?.() ||
      surfaces[0];
    const results = [];

    document.activeElement?.blur?.();
    window.SmoofEditorState?.deselect?.();
    await document.fonts?.ready;
    await delay(140);

    try {
      for (const surface of surfaces) {
        if (store && surfaces.length > 1) {
          await activateSurface(
            store,
            surface
          );
        }

        results.push({
          surface,
          model:
            renderer.readModel()
        });
      }
    } finally {
      if (
        store &&
        surfaces.length > 1 &&
        store.getActive() !== originalSurface
      ) {
        await activateSurface(
          store,
          originalSurface
        );
      }
    }

    return results;
  }

  async function createProofDownloads() {
    const proofId = createProofId();
    const surfaceModels = await captureSurfaceModels();
    const results = [];

    for (const surfaceModel of surfaceModels) {
      results.push(
        await createProofFile(
          proofId,
          surfaceModel
        )
      );
    }

    return results;
  }

  async function createProductionDownloads() {
    const productionId = createProofId();
    const surfaceModels = await captureSurfaceModels();
    const results = [];

    for (const surfaceModel of surfaceModels) {
      results.push(
        await createProductionFile(
          productionId,
          surfaceModel
        )
      );
    }

    return results;
  }

  async function generateForCart(
    form,
    submitter
  ) {
    if (generationPromise) return;

    if (submitter) {
      submitter.setAttribute(
        'aria-busy',
        'true'
      );
      submitter.dataset.smoofPdfBusy =
        'true';

      showProcessingLabel(
        submitter
      );
    }

    showWorkingStatus();

    const jobId =
      createProofId();

    generationPromise =
      (async () => {
        const surfaceModels =
          await captureSurfaceModels();

        const proofs = [];
        const productions = [];

        for (const surfaceModel of surfaceModels) {
          proofs.push(
            await createProofFile(
              jobId,
              surfaceModel
            )
          );
          productions.push(
            await createProductionFile(
              jobId,
              surfaceModel
            )
          );
        }

        const cartPreviews = [];

        for (const proof of proofs) {
          cartPreviews.push({
            name: proofs.length > 1
              ? `properties[Vorschau ${surfaceLabel(proof.surface)}]`
              : CART_PREVIEW_INPUT_NAME,
            file: await createCartPreviewFile(
              proof.artworkBytes,
              jobId,
              proof.surface,
              proofs.length
            )
          });
        }

        return {
          proofs,
          productions,
          cartPreviews
        };
      })();

    try {
      const result =
        await generationPromise;

      clearGeneratedFileInputs(form);

      result.proofs.forEach(proof => {
        attachProofToForm(
          form,
          proof.file,
          proof.proofId,
          proof.diameter,
          proof.surface,
          result.proofs.length,
          proof.qr
        );
      });

      result.productions.forEach(production => {
        attachProductionToForm(
          form,
          production.file,
          production.productionId,
          production.productionResult,
          production.surface,
          result.productions.length
        );
      });

      attachCartPreviewToForm(
        form,
        result.cartPreviews
      );

      readyForms.add(form);

      if (submitter) {
        submitter.removeAttribute(
          'aria-busy'
        );
        delete submitter.dataset
          .smoofPdfBusy;

        clearThemeLoadingShim(
          submitter
        );

        restoreProcessingLabel(
          submitter
        );
      }

      hideStatus();

      if (
        submitter &&
        typeof submitter.click ===
          'function'
      ) {
        /*
         * Easify hängt kostenpflichtige Zusatzprodukte
         * an seinen normalen Button-Klick. Deshalb wird
         * nach der PDF-Erzeugung exakt dieser Klick erneut
         * abgespielt. readyForms verhindert dabei einen
         * zweiten PDF-Durchlauf.
         */
        submitter.click();
      } else {
        form.requestSubmit();
      }

      window.setTimeout(
        () => {
          readyForms.delete(form);
          cartPreviewFiles.delete(
            form
          );
        },
        5000
      );
    } catch (error) {
      cartPreviewFiles.delete(
        form
      );

      if (submitter) {
        submitter.removeAttribute(
          'aria-busy'
        );
        delete submitter.dataset
          .smoofPdfBusy;

        clearThemeLoadingShim(
          submitter
        );

        restoreProcessingLabel(
          submitter
        );
      }

      showErrorStatus(error);
    } finally {
      generationPromise = null;
    }
  }

  function isProductForm(form) {
    if (!(form instanceof HTMLFormElement)) {
      return false;
    }

    return (
      /\/cart\/add/i.test(
        form.action || ''
      ) ||
      Boolean(
        form.querySelector(
          'input[name="id"]'
        )
      )
    );
  }

  function isPersonalizedEditorActive() {
    const stage =
      document.querySelector(
        STAGE_SELECTOR
      );

    if (!stage) return false;

    const style =
      window.getComputedStyle(stage);

    const rect =
      stage.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || 1) > 0 &&
      rect.width > 1 &&
      rect.height > 1
    );
  }

  function isAddButton(button) {
    if (!button) return false;

    const type =
      String(
        button.type || ''
      ).toLowerCase();

    const label =
      [
        button.name,
        button.value,
        button.textContent,
        button.getAttribute(
          'aria-label'
        )
      ].join(' ').toLowerCase();

    return (
      type === 'submit' ||
      button.name === 'add' ||
      button.hasAttribute(
        'data-add-to-cart'
      ) ||
      /warenkorb|einkaufswagen|add to cart/.test(
        label
      )
    );
  }

  function getSelectedVariantAvailability(
    form
  ) {
    const variantId =
      form?.querySelector(
        'input[name="id"]'
      )?.value;

    if (!variantId) return null;

    const productInfo =
      form.closest('product-info') ||
      document;

    const scripts =
      productInfo.querySelectorAll(
        'variant-picker script[type="application/json"]'
      );

    for (const script of scripts) {
      try {
        const parsed =
          JSON.parse(
            script.textContent || ''
          );

        const variants =
          Array.isArray(parsed)
            ? parsed
            : [parsed];

        const variant =
          variants.find(item =>
            String(item?.id) ===
            String(variantId)
          );

        if (variant) {
          return (
            variant.available === true
          );
        }
      } catch (error) {
        /* Andere JSON-Daten ignorieren. */
      }
    }

    return null;
  }

  function clearThemeLoadingShim(
    button
  ) {
    if (
      !button?.dataset
        .smoofThemeLoadingShim
    ) {
      return;
    }

    button.removeAttribute(
      'loading'
    );

    delete button.dataset
      .smoofThemeLoadingShim;

    if (
      !button.dataset.smoofPdfBusy
    ) {
      restoreProcessingLabel(
        button
      );
    }
  }

  function showProcessingLabel(
    button
  ) {
    const label =
      button?.querySelector(
        '.btn-text > span'
      );

    if (!label) return;

    if (
      !button.dataset
        .smoofOriginalButtonLabel
    ) {
      button.dataset
        .smoofOriginalButtonLabel =
        label.textContent || '';
    }

    label.textContent =
      text(
        'Wird verarbeitet …',
        'Processing …'
      );
  }

  function restoreProcessingLabel(
    button
  ) {
    const original =
      button?.dataset
        .smoofOriginalButtonLabel;

    const label =
      button?.querySelector(
        '.btn-text > span'
      );

    if (
      label &&
      original !== undefined
    ) {
      label.textContent = original;
    }

    if (button?.dataset) {
      delete button.dataset
        .smoofOriginalButtonLabel;
    }
  }

  function ensureThemeLoadingShim(
    button,
    form
  ) {
    if (
      !button ||
      button.hasAttribute(
        'unavailable'
      ) ||
      getSelectedVariantAvailability(
        form
      ) !== true
    ) {
      return;
    }

    if (
      !button.hasAttribute(
        'loading'
      )
    ) {
      button.setAttribute(
        'loading',
        ''
      );

      button.dataset
        .smoofThemeLoadingShim =
        'true';
    }

    showProcessingLabel(
      button
    );

    window.setTimeout(
      () => {
        if (
          !button.disabled &&
          !button.dataset
            .smoofPdfBusy
        ) {
          clearThemeLoadingShim(
            button
          );
        }
      },
      1600
    );
  }

  function ensureTestButton() {
    let downloadHooks =
      document.querySelector(
        '[data-smoof-pdf-download-hooks]'
      );

    if (!downloadHooks) {
      downloadHooks =
        document.createElement('div');
      downloadHooks.dataset
        .smoofPdfDownloadHooks =
        'true';
      downloadHooks.hidden = true;
      document.body.appendChild(
        downloadHooks
      );
    }

    if (
      !downloadHooks.querySelector(
        '[data-smoof-proof-test-button]'
      )
    ) {
      const proofButton =
        document.createElement(
          'button'
        );

      proofButton.type =
        'button';

      proofButton.dataset
        .smoofProofTestButton =
        'true';

      proofButton.textContent =
        'PDF Download';

      proofButton.addEventListener(
        'click',
        async event => {
          event.preventDefault();
          event.stopPropagation();

          if (generationPromise) return;

          showWorkingStatus();

          const overlay =
            ensureStatusOverlay();

          overlay.querySelector(
            '[data-smoof-proof-status-title]'
          ).textContent =
            text(
              window.SmoofSurfaceStore?.surfaces?.length > 1
                ? 'Proof-PDFs werden erstellt'
                : 'Proof-PDF wird erstellt',
              window.SmoofSurfaceStore?.surfaces?.length > 1
                ? 'Creating proof PDFs'
                : 'Creating proof PDF'
            );

          overlay.querySelector(
            '[data-smoof-proof-status-copy]'
          ).textContent =
            text(
              window.SmoofSurfaceStore?.surfaces?.length > 1
                ? 'Vorder- und Rückseite werden erstellt und gemeinsam als proof-front-back.zip heruntergeladen.'
                : 'Die Proof-PDF wird erstellt und anschließend heruntergeladen.',
              window.SmoofSurfaceStore?.surfaces?.length > 1
                ? 'Front and back are being created and downloaded together as proof-front-back.zip.'
                : 'The proof PDF is being created and will then be downloaded.'
            );

          generationPromise =
            createProofDownloads();

          try {
            const results =
              await generationPromise;

            downloadFile(
              await createDownloadBundle(
                results,
                'proof-front-back.zip'
              )
            );

            hideStatus();
          } catch (error) {
            showErrorStatus(error);
          } finally {
            generationPromise =
              null;
          }
        }
      );

      downloadHooks.appendChild(
        proofButton
      );
    }

    if (
      downloadHooks.querySelector(
        '[data-smoof-production-test-button]'
      )
    ) {
      return;
    }

    const productionButton =
      document.createElement(
        'button'
      );

    productionButton.type =
      'button';

    productionButton.dataset
      .smoofProductionTestButton =
      'true';

    productionButton.textContent =
      text(
        'Produktionsvorlage PDF',
        'Production template PDF'
      );

    productionButton.addEventListener(
      'click',
      async event => {
        event.preventDefault();
        event.stopPropagation();

        if (generationPromise) return;

        showWorkingStatus();

        const overlay =
          ensureStatusOverlay();

        overlay.querySelector(
          '[data-smoof-proof-status-title]'
        ).textContent =
          text(
            window.SmoofSurfaceStore?.surfaces?.length > 1
              ? 'Produktionsvorlagen werden erstellt'
              : 'Produktionsvorlage wird erstellt',
            window.SmoofSurfaceStore?.surfaces?.length > 1
              ? 'Creating production templates'
              : 'Creating production template'
          );

        overlay.querySelector(
          '[data-smoof-proof-status-copy]'
        ).textContent =
          text(
            window.SmoofSurfaceStore?.surfaces?.length > 1
              ? 'Vorder- und Rückseite werden mit 2,5 mm Beschnitt erstellt und gemeinsam als production-front-back.zip heruntergeladen.'
              : 'Die quadratische PDF mit 2,5 mm Beschnitt wird erstellt und anschließend heruntergeladen.',
            window.SmoofSurfaceStore?.surfaces?.length > 1
              ? 'Front and back are created with 2.5 mm bleed and downloaded together as production-front-back.zip.'
              : 'The square PDF with 2.5 mm bleed is being created and will then be downloaded.'
          );

        generationPromise =
          createProductionDownloads();

        try {
          const results =
            await generationPromise;

          downloadFile(
            await createDownloadBundle(
              results,
              'production-front-back.zip'
            )
          );

          hideStatus();
        } catch (error) {
          showErrorStatus(error);
        } finally {
          generationPromise = null;
        }
      }
    );

    downloadHooks.appendChild(
      productionButton
    );
  }

  function render() {
    const stage =
      document.querySelector(
        STAGE_SELECTOR
      );

    if (stage) {
      ensureWhitePanel(stage);
    } else {
      whitePanel?.remove();
      whitePanel = null;
      currentStage = null;
    }

    ensureTestButton();

    const marker =
      document.querySelector(
        '#smoof-preview-extension'
      );

    if (marker) {
      marker.dataset
        .smoofProofPdfStatus =
        'active';

      marker.dataset
        .smoofProofPdfVersion =
        VERSION;
    }
  }

  function scheduleRender() {
    if (renderPending) return;

    renderPending = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderPending = false;
        render();
      });
    });
  }

  window.addEventListener(
    'click',
    event => {
      const button =
        event.target.closest?.(
          'button, input[type="submit"], input[type="image"]'
        );

      const form =
        button?.closest?.('form');

      if (
        isProductForm(form) &&
        isAddButton(button)
      ) {
        ensureThemeLoadingShim(
          button,
          form
        );
      }

      if (
        !isProductForm(form) ||
        !isAddButton(button) ||
        !isPersonalizedEditorActive() ||
        readyForms.has(form)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      generateForCart(
        form,
        button
      );
    },
    true
  );

  window.addEventListener(
    'submit',
    event => {
      const form =
        event.target;

      if (
        !isProductForm(form) ||
        !isPersonalizedEditorActive() ||
        readyForms.has(form)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      generateForCart(
        form,
        event.submitter || null
      );
    },
    true
  );

  document.addEventListener(
    'input',
    scheduleRender,
    true
  );

  document.addEventListener(
    'change',
    scheduleRender,
    true
  );

  new MutationObserver(
    scheduleRender
  ).observe(document.body, {
    childList: true,
    subtree: true
  });

  new MutationObserver(
    mutations => {
      mutations.forEach(
        mutation => {
          const button =
            mutation.target;

          if (
            !isAddButton(button)
          ) {
            return;
          }

          const form =
            button.closest?.('form');

          if (!isProductForm(form)) {
            return;
          }

          if (button.disabled) {
            ensureThemeLoadingShim(
              button,
              form
            );
          } else {
            clearThemeLoadingShim(
              button
            );
          }
        }
      );
    }
  ).observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: [
      'disabled',
      'unavailable'
    ]
  });

  window.addEventListener(
    'resize',
    scheduleRender
  );

  window.SmoofProofPdf =
    Object.freeze({
      version: VERSION,
      rendererBuild:
        REQUIRED_RENDERER_BUILD,
      buildProofPdf,
      buildProductionPdf,
      createProofFile,
      createProductionFile
    });

  scheduleRender();
})();
